export const PlatformName = 'ClientApp';
export const SecretKey = 'SecretKey';
